import React, { useEffect, useRef, useState } from "react";
import homedata from "../../data/home.json";
import axios from "axios";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import WhatsAppIcons from "./whatsapp";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const serviceAreas = [
  {
    name: "Oklahoma City",
    latitude: 35.46756,
    longitude: -97.51643,
  },
  {
    name: "Edmond",
    latitude: 35.6528323,
    longitude: -97.4780954,
  },
  {
    name: "Norman",
    latitude: 35.2226,
    longitude: -97.4395,
  },
  {
    name: "Moore",
    latitude: 35.338333,
    longitude: -97.486667,
  },
  {
    name: "Guthrie",
    latitude: 35.878937,
    longitude: -97.425316,
  },
  {
    name: "Arcadia",
    latitude: 35.665556,
    longitude: -97.326389,
  },
  {
    name: "Yukon",
    latitude: 35.50672,
    longitude: -97.76254,
  },
  {
    name: "Mustang",
    latitude: 35.38423,
    longitude: -97.72449,
  },
  {
    name: "Del City",
    latitude: 35.442778,
    longitude: -97.441111,
  },
  {
    name: "Midwest City",
    latitude: 35.4495,
    longitude: -97.396694,
  },
];

const metroArea = {
  name: "Oklahoma City Metro Area",
  latitude: 35.46756,
  longitude: -97.51643,
};

const createGoogleMapsUrl = (name) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${name}, Oklahoma`,
  )}`;

const ServiceAreasMap = () => {
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef({});

  useEffect(() => {
    if (!mapContainerRef.current || mapInstanceRef.current) {
      return undefined;
    }

    const map = L.map(mapContainerRef.current, {
      center: [metroArea.latitude, metroArea.longitude],
      zoom: 9,
      minZoom: 7,
      maxZoom: 18,
      scrollWheelZoom: false,
      zoomControl: true,
    });

    mapInstanceRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors',
    }).addTo(map);

    const bounds = L.latLngBounds([]);

    serviceAreas.forEach((area, index) => {
      const markerIcon = L.divIcon({
        className: "service-area-marker-container",
        html: `
          <div class="service-area-marker">
            <span>${index + 1}</span>
          </div>
        `,
        iconSize: [38, 46],
        iconAnchor: [19, 46],
        popupAnchor: [0, -42],
        tooltipAnchor: [0, -38],
      });

      const marker = L.marker([area.latitude, area.longitude], {
        icon: markerIcon,
        title: area.name,
        keyboard: true,
      }).addTo(map);

      marker.bindTooltip(area.name, {
        direction: "top",
        offset: [0, -10],
        opacity: 1,
        className: "service-area-tooltip",
      });

      marker.bindPopup(`
        <div class="service-area-popup">
          <strong>${area.name}</strong>

          <p>
            Professional painting services available in
            ${area.name}, Oklahoma.
          </p>

          <a
            href="${createGoogleMapsUrl(area.name)}"
            target="_blank"
            rel="noreferrer"
          >
            View on Google Maps
          </a>
        </div>
      `);

      markersRef.current[area.name] = marker;
      bounds.extend([area.latitude, area.longitude]);
    });

    const metroCircle = L.circle([metroArea.latitude, metroArea.longitude], {
      radius: 51000,
      color: "#0d3559",
      weight: 2,
      fillColor: "#0d3559",
      fillOpacity: 0.06,
      dashArray: "8 8",
      interactive: true,
    }).addTo(map);

    metroCircle.bindPopup(`
      <div class="service-area-popup">
        <strong>Oklahoma City Metro Area</strong>

        <p>
          General service coverage throughout the Oklahoma City
          metropolitan area.
        </p>
      </div>
    `);

    if (bounds.isValid()) {
      map.fitBounds(bounds, {
        padding: [45, 45],
        maxZoom: 10,
      });
    }

    setTimeout(() => {
      map.invalidateSize();
    }, 150);

    return () => {
      markersRef.current = {};

      map.remove();
      mapInstanceRef.current = null;
    };
  }, []);

  const focusArea = (area) => {
    const map = mapInstanceRef.current;
    const marker = markersRef.current[area.name];

    if (!map || !marker) {
      return;
    }

    map.flyTo([area.latitude, area.longitude], 13, {
      animate: true,
      duration: 1.2,
    });

    window.setTimeout(() => {
      marker.openPopup();
    }, 900);
  };

  const showAllAreas = () => {
    const map = mapInstanceRef.current;

    if (!map) {
      return;
    }

    const bounds = L.latLngBounds(
      serviceAreas.map((area) => [area.latitude, area.longitude]),
    );

    map.flyToBounds(bounds, {
      padding: [45, 45],
      maxZoom: 10,
      animate: true,
      duration: 1.2,
    });
  };

  return (
    <>
      <div className="service-area-buttons">
        {serviceAreas.map((area, index) => (
          <button
            key={area.name}
            type="button"
            className="service-area-button"
            onClick={() => focusArea(area)}
          >
            <span className="service-area-button-number">{index + 1}</span>
            {area.name}
          </button>
        ))}

        <button
          type="button"
          className="service-area-button service-area-button-wide"
          onClick={showAllAreas}
        >
          Oklahoma City Metro Area
        </button>
      </div>

      <div className="service-areas-map-wrapper">
        <div
          ref={mapContainerRef}
          className="service-areas-map"
          aria-label="John 316 Painting service areas map"
        />

        <div className="service-areas-map-label">
          <strong>John 3:16 Painting LLC</strong>
          <span>Oklahoma City Metro Area</span>
        </div>
      </div>
    </>
  );
};

const Contact = () => {
  const [cargando, setCargando] = useState(false);

  const envioDeCorreo = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    const formData = new FormData(form);

    const nombre = String(formData.get("name") || "").trim();
    const correo = String(formData.get("email") || "").trim();
    const telefono = String(formData.get("phone") || "").trim();
    const direccion = String(formData.get("address") || "").trim();
    const interesado = String(formData.get("interested") || "").trim();

    const mensaje = `
Name: ${nombre}
E-mail: ${correo}
Phone: ${telefono}
Address: ${direccion}
Interested in: ${interesado}
    `.trim();

    const data = {
      nombre,
      correo,
      mensaje,
      nombreProp: "John 3:16 Painting LLC",
      correoProp: "contact@john316painting.com",
      pagina: "john316painting.com",
    };

    try {
      setCargando(true);

      await axios.post(
        "https://taeconta.com/api/public/api/correos/publicos",
        data,
      );

      await Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Message sent successfully",
        showConfirmButton: false,
        timer: 1500,
      });

      form.reset();
    } catch (error) {
      console.error("Error al enviar el correo:", error);

      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message;

      await Swal.fire({
        icon: "error",
        title: "Error sending message",
        text: backendMessage || "The message could not be sent.",
      });
    } finally {
      setCargando(false);
    }
  };

  const contactInfo = homedata.contact;
  const sectionHeadingInfo = contactInfo.sectionHeading;
  const publicUrl = process.env.PUBLIC_URL || "";

  const inlineStyle = {
    backgroundImage: `url(${publicUrl}${contactInfo.bgImg})`,
  };

  return (
    <>
      <style>
        {`
          .service-area-buttons {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 12px;
            margin: 0 0 30px;
          }

          .service-area-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 9px;
            min-height: 58px;
            padding: 12px 20px;
            border: 1px solid rgba(13, 53, 89, 0.14);
            border-radius: 10px;
            background: #ffffff;
            color: #0d3559;
            font: inherit;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.2;
            cursor: pointer;
            box-shadow: 0 8px 22px rgba(13, 53, 89, 0.1);
            transition:
              transform 160ms ease,
              box-shadow 160ms ease,
              background-color 160ms ease,
              color 160ms ease;
          }

          .service-area-button:hover {
            color: #ffffff;
            background: #0d3559;
            box-shadow: 0 12px 28px rgba(13, 53, 89, 0.22);
            transform: translateY(-2px);
          }

          .service-area-button:focus-visible {
            outline: 3px solid rgba(245, 134, 52, 0.45);
            outline-offset: 3px;
          }

          .service-area-button-number {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 25px;
            height: 25px;
            flex: 0 0 25px;
            border-radius: 50%;
            background: #f58634;
            color: #ffffff;
            font-size: 13px;
            font-weight: 700;
          }

          .service-area-button-wide {
            min-width: 270px;
          }

          .service-areas-map-wrapper {
            position: relative;
            overflow: hidden;
            border: 1px solid rgba(13, 53, 89, 0.14);
            border-radius: 12px;
            background: #ffffff;
            box-shadow: 0 18px 45px rgba(0, 0, 0, 0.18);
          }

          .service-areas-map {
            width: 100%;
            height: 520px;
            background: #e9eef2;
            z-index: 1;
          }

          .service-areas-map-label {
            position: absolute;
            top: 18px;
            left: 58px;
            z-index: 500;
            display: flex;
            flex-direction: column;
            min-width: 235px;
            padding: 12px 16px;
            border-radius: 9px;
            background: rgba(255, 255, 255, 0.96);
            color: #0d3559;
            text-align: left;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
            pointer-events: none;
          }

          .service-areas-map-label strong {
            font-size: 15px;
            line-height: 1.35;
          }

          .service-areas-map-label span {
            margin-top: 2px;
            color: #667792;
            font-size: 13px;
            line-height: 1.35;
          }

          .service-area-marker-container {
            border: 0;
            background: transparent;
          }

          .service-area-marker {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            border: 3px solid #ffffff;
            border-radius: 50% 50% 50% 0;
            background: #f58634;
            color: #ffffff;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.34);
            transform: rotate(-45deg);
          }

          .service-area-marker span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            font-size: 12px;
            font-weight: 700;
            transform: rotate(45deg);
          }

          .service-area-tooltip {
            padding: 7px 11px;
            border: 0;
            border-radius: 6px;
            background: #0d3559;
            color: #ffffff;
            font-size: 13px;
            font-weight: 600;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
          }

          .service-area-tooltip::before {
            border-top-color: #0d3559;
          }

          .service-area-popup {
            min-width: 190px;
            color: #263746;
            text-align: left;
          }

          .service-area-popup strong {
            display: block;
            margin-bottom: 7px;
            color: #0d3559;
            font-size: 16px;
          }

          .service-area-popup p {
            margin: 0 0 10px;
            color: #5e6d79;
            font-size: 13px;
            line-height: 1.5;
          }

          .service-area-popup a {
            display: inline-block;
            color: #0d3559;
            font-size: 13px;
            font-weight: 700;
            text-decoration: none;
          }

          .service-area-popup a:hover {
            text-decoration: underline;
          }

          .leaflet-control-zoom a {
            color: #0d3559;
          }

          .leaflet-popup-content-wrapper {
            border-radius: 9px;
          }

          @media (max-width: 767px) {
            .service-area-buttons {
              gap: 9px;
            }

            .service-area-button {
              width: calc(50% - 5px);
              min-height: 54px;
              padding: 10px 12px;
              font-size: 14px;
            }

            .service-area-button-wide {
              width: 100%;
              min-width: 0;
            }

            .service-areas-map {
              height: 440px;
            }

            .service-areas-map-label {
              top: 12px;
              right: 12px;
              left: auto;
              min-width: 0;
              max-width: calc(100% - 74px);
              padding: 9px 12px;
            }
          }

          @media (max-width: 480px) {
            .service-area-button {
              width: 100%;
            }

            .service-areas-map {
              height: 400px;
            }
          }
        `}
      </style>

      <section
        id="contact"
        className="pt100 pb100 bg-parallax"
        style={inlineStyle}
      >
        <WhatsAppIcons />

        <div className="color-overlay opacity-8" />

        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="contact-block text-center">
                <div className="col-sm-12">
                  <h3>{sectionHeadingInfo.title}</h3>
                  <p className="subtitle">{sectionHeadingInfo.desc}</p>
                </div>

                <form id="contact-form" onSubmit={envioDeCorreo}>
                  <div className="row">
                    <div className="col-sm-12">
                      <input
                        name="name"
                        className="contact-name form-control input-box"
                        id="contact-name"
                        type="text"
                        placeholder="Name"
                        autoComplete="name"
                        required
                      />
                    </div>

                    <div className="col-sm-12">
                      <input
                        name="email"
                        className="contact-email form-control input-box"
                        id="contact-email"
                        type="email"
                        placeholder="E-mail"
                        autoComplete="email"
                        required
                      />
                    </div>

                    <div className="col-sm-12">
                      <input
                        name="phone"
                        className="contact-phone form-control input-box"
                        id="contact-phone"
                        type="tel"
                        placeholder="Phone"
                        autoComplete="tel"
                        required
                      />
                    </div>

                    <div className="col-sm-12">
                      <input
                        name="address"
                        className="contact-address form-control input-box"
                        id="contact-address"
                        type="text"
                        placeholder="Address"
                        autoComplete="street-address"
                        required
                      />
                    </div>

                    <div className="col-sm-12">
                      <label
                        htmlFor="contact-interested"
                        style={{
                          display: "block",
                          marginBottom: "20px",
                          color: "#667792",
                          fontSize: "20px",
                          fontWeight: 400,
                          textAlign: "center",
                        }}
                      >
                        Interested in:
                      </label>

                      <select
                        name="interested"
                        className="contact-interested form-control input-box"
                        id="contact-interested"
                        required
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select an option
                        </option>

                        <option value="Interior">Interior</option>
                        <option value="Exterior">Exterior</option>
                        <option value="Cabinets">Cabinets</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="col-sm-12">
                      <button
                        type="submit"
                        className="primary-btn"
                        disabled={cargando}
                      >
                        {cargando ? (
                          <ReactLoading type="cylon" width={42} height={24} />
                        ) : (
                          <>
                            <i
                              className="fa fa-paper-plane"
                              aria-hidden="true"
                            />{" "}
                            {contactInfo.submitBtnLabel}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>

                <div className="col-lg-8 offset-lg-2 mt-5">
                  <h3>Hours of Operation</h3>
                  <p>Monday – Friday: 8:00 AM – 6:00 PM</p>
                  <p>Saturday: 8:00 AM – 1:00 PM</p>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "14px",
                      marginTop: "20px",
                    }}
                  >
                    <a
                      href="tel:+14053153991"
                      aria-label="Call John 316 Painting"
                      title="Call us"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#0d3559",
                        color: "#ffffff",
                        textDecoration: "none",
                        fontSize: "22px",
                      }}
                    >
                      <i className="fa fa-phone" aria-hidden="true"></i>
                    </a>

                    <a
                      href="https://wa.me/14053153991"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Contact John 316 Painting on WhatsApp"
                      title="Contact us on WhatsApp"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#25D366",
                        color: "#ffffff",
                        textDecoration: "none",
                        fontSize: "24px",
                      }}
                    >
                      <i className="fa fa-whatsapp" aria-hidden="true"></i>
                    </a>

                    <a
                      href="tel:+14053153991"
                      style={{
                        color: "#0d3559",
                        fontSize: "18px",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                    >
                      (405) 315-3991
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-block text-center">
                <h3>Service Areas</h3>

                <p style={{ color: "#555", marginBottom: "25px" }}>
                  We proudly serve these communities in the Oklahoma City Metro
                  Area.
                </p>

                <ServiceAreasMap />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
